export const API_PATH = "http://localhost:8080";
// export const API_PATH = "https://srisairamadvertising.com";